import { CommunicationOptions } from "@fluentui/react-teams";
import ReactTeamsCommunication from "components/organisms/ReactTeamsCommunication";
import { MsWwwAuthHeader } from "libs/auth";
import { errorWrap } from "libs/error";
import { TranslationKey } from "libs/locale/i18nLanguages";
import { authenticate } from "libs/teams/helper";
import { useErrorHandler } from "react-error-boundary";
import { useTranslation } from "react-i18next";

type Props = MsWwwAuthHeader;

export default function InteractionRequired({ consentUri }: Props) {
  const handleError = useErrorHandler();
  const { t } = useTranslation();

  async function handleInteraction(target: string) {
    switch (target) {
      case "consent":
        try {
          await authenticate(consentUri);
          // 권한 동의 완료시 새로고침
          window.location.reload();
        } catch (error) {
          handleError(errorWrap(error, "handleInteraction() 에러"));
        }
        break;
    }
  }

  return (
    <ReactTeamsCommunication
      option={CommunicationOptions.Welcome}
      fields={{
        title: t(TranslationKey["처음이신가요?"]),
        desc: t(
          TranslationKey[
            "앱 사용이 처음인 경우, 최초 1회 사용 동의가 필요합니다."
          ]
        ),
        actions: {
          primary: {
            label: t(TranslationKey["사용 동의"]),
            target: "consent",
          },
        },
      }}
      onInteraction={({ target }) => handleInteraction(target)}
    />
  );
}
